class DailyBalanceSheetPrintController {
    /*@ngInject*/
    constructor($state, $stateParams) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.balanceSheetData = '';
        this.totalLiability = 0;
        this.total = 0;
        this.manualDeposit = false;
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
        }
        this.balanceSheetData = printData.data;
        this.currency = printData.currency || '$';
        this.branch = printData.branch;
        this.vaultDate = printData.vaultDate;
        this.totalLiability = this.balanceSheetData.totalLiability;
        this.manualDeposit = printData.manualDeposit;

        setTimeout(() => {
            window.print()
        }, 1500)
    }
}

export default DailyBalanceSheetPrintController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/daily_balance_sheet_print.controller.js